import type {ThunkResult} from "../../../app/reducers/IMainAppState";
import type Popup from "../objects/Popup";
import {CLOSE_POPUP, OPEN_POPUP} from "../reducers/PopupReducer";

export function OpenPopup(popup: Popup): ThunkResult<void> {
    return (dispatch) => {
        dispatch({
            type: OPEN_POPUP,
            popup
        });
    };
}
export type OpenPopupThunkType = (popup: Popup) => void;

export function ClosePopup(popup: Popup): ThunkResult<void> {
    return (dispatch) => {
        dispatch({
            type: CLOSE_POPUP,
            popup
        })
    };
}
export type ClosePopupThunkType = (popup: Popup) => void;